import React, { useEffect, useState } from "react";
import variables from "../../../constants/assets/variables";
import FileUpload from "../../Common/FileUpload";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as LeadsBulkUploadActions from "../../../store/actions/LeadsBulkUpload";

import NoFooterModal from "../../Common/NoFooterModal";
import styled from "styled-components";
import Button from "sushiweb/Button";
import InformationBar from "../../Common/InformationBar";

import {
  BottomSectionModal,
  Link,
  UploadCsvOption,
  NotesSection,
} from "../../../constants/assets/containers";

const UploadLeadsModal = (props) => {
  const { bulkUploadLeads } = props;
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const sample_download_url = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}/sample/bulk_upload_leads.csv`
      : ""
  }`;

  const instructions = [
    "Please provide data as per the format in the sample file.",
    "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
  ];

  const handleClose = () => {
    history.push("/");
  };

  const handleSubmit = () => {
    activeFile &&
      bulkUploadLeads(activeFile).then(() => {
        handleClose();
      });
  };

  const handleFileChange = (file) => {
    setActiveFile(file);
  };

  return (
    <BulkUploadLeadsModal>
      <NoFooterModal
        header
        heading="Bulk Upload Leads"
        handleClose={handleClose}
        id="uploadLeadsModal"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="assignCourse"
              disabled={activeFile === ""}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <UploadCsvOption>
          <FileUpload
            title="CSV"
            activeFile={activeFile}
            setActiveFile={handleFileChange}
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </BulkUploadLeadsModal>
  );
};

const BulkUploadLeadsModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    bulkUploadLeads: bindActionCreators(
      LeadsBulkUploadActions.bulkUploadLeads,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(UploadLeadsModal);
